import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

export const startSearch = action(
    'START_SEARCH_NEXT',
    (actionSource: string, scenarioId: SearchScenarioId, explicitSearch: boolean = false) => ({
        actionSource,
        scenarioId,
        explicitSearch,
    })
);

export default startSearch;
